import fetchApi from "./fetchApi";

export const GetFetcher = ({ url, params }: { url: string; params: any }) =>
    fetchApi.get(url, params).then((res) => res.data);
export const PostFetcher = (url: string, params: any) =>
    fetchApi.post(url, params).then((res) => res.data);
